export const updateUrl = (queryParams) =>
    window.history.replaceState(null, null, `?${queryParams.toString()}`);

export const changeUrl = (queryParams) => (window.location.href = `?${queryParams.toString()}`);

export const getQueryParams = (location = window.location.search) => new URLSearchParams(location);

export const updateQueryParam = (
    queryParams,
    queryKey,
    value,
    runUpdateUrlFunc = true,
    runChangeUrlFunc = false
) => {
    if (value) {
        const queryValue = Array.isArray(value) ? value.join(",") : value;
        queryParams.set(queryKey, queryValue);
    } else {
        if (queryParams.has(queryKey)) queryParams.delete(queryKey);
    }

    if (runUpdateUrlFunc) updateUrl(queryParams);

    if (runChangeUrlFunc) changeUrl(queryParams);
};

export const updateQueryParams = (queryParams, values) => {
    for (const [queryKey, value] of Object.entries(values)) {
        updateQueryParam(queryParams, queryKey, value, false);
    }

    updateUrl(queryParams);
};

export const getQueryParamValueByKey = (queryParams, queryKey) => {
    const queryValues = getQueryParamsValues(queryParams);

    return queryValues[queryKey];
};

export const getQueryParamsValues = (queryParams) => {
    const values = {};

    for (const [queryKey, queryValue] of queryParams.entries()) {
        values[queryKey] = decodeURIComponent(queryValue);
    }

    return values;
};

export const updateQueryParamsByFilters = (queryParams, filters) => {
    for (const [filterName, filterObj] of Object.entries(filters)) {
        updateQueryParam(queryParams, filterName, filterObj.value, false);
    }

    updateUrl(queryParams);
};
